import dayjs from 'dayjs'

// Resolve the viewer's IANA timezone so "today/week/..." reflects local time.
export function getTimezone() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
    } catch {
        return 'UTC'
    }
}

export const RANGES = [
    { value: 'today', label: 'Today' },
    { value: 'week', label: 'Week' },
    { value: 'month', label: 'Month' },
    { value: 'year', label: 'Year' },
]

// Series colors, mapped to the theme chart tokens defined in globals.css.
export const CHART_COLORS = [
    'var(--chart-2)',
    'var(--chart-1)',
    'var(--chart-4)',
    'var(--chart-3)',
    'var(--chart-5)',
]

// Format a bucket timestamp for an axis tick based on the active resolution.
export function formatTick(ts, resolution) {
    const d = dayjs(ts)
    if (resolution === 'hour') return d.format('HH:00')
    if (resolution === 'month') return d.format('MMM YY')
    return d.format('MMM D')
}

// Compact human-readable duration from a number of seconds (e.g. 5s, 1m 12s, 2h 3m).
export function formatDuration(totalSeconds) {
    const s = Math.max(0, Math.round(totalSeconds || 0))
    if (s < 60) return `${s}s`
    const m = Math.floor(s / 60)
    const secs = s % 60
    if (m < 60) return secs ? `${m}m ${secs}s` : `${m}m`
    const h = Math.floor(m / 60)
    const mins = m % 60
    return mins ? `${h}h ${mins}m` : `${h}h`
}

// Longer label used inside tooltips.
export function formatTooltipLabel(ts, resolution) {
    const d = dayjs(ts)
    if (resolution === 'hour') return d.format('MMM D, HH:00')
    if (resolution === 'month') return d.format('MMMM YYYY')
    return d.format('MMM D, YYYY')
}
